import { Directive, AfterViewInit, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[autofocus]'
})
export class AutofocusDirective implements AfterViewInit {

  constructor(private el: ElementRef) {
  }

  @Input() index

  ngAfterViewInit() {
    if (this.index === 0)
      this.el.nativeElement.focus();
  }

}